import axios from 'axios';
import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const BASE_PATH = '/api/v1/raw-odds';

const getAuthHeaders = () => {
    const token = authService.getToken();
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

const handleApiError = (error) => {
    if (error.response) {
        const { status, data } = error.response;

        if (status === 401) {
            return {
                success: false,
                status,
                errorCode: data.error || 'UNAUTHORIZED',
                message: data.message || 'Authentication failed',
                isAuthError: true
            };
        }

        if (status === 403) {
            return {
                success: false,
                status,
                errorCode: data.error || 'SUBSCRIPTION_REQUIRED',
                message: data.message || 'A Snipe Pro or Snipe Elite subscription is required to access raw odds data. Please upgrade your plan.',
                isSubscriptionError: true
            };
        }

        if (status === 400) {
            return {
                success: false,
                status,
                errorCode: data.error || 'VALIDATION_ERROR',
                message: data.message || 'Invalid request parameters',
                details: data.errors || []
            };
        }

        if (status === 429) {
            return {
                success: false,
                status,
                errorCode: data.error || 'RATE_LIMIT_EXCEEDED',
                message: data.message || 'Too many requests. Please try again in a minute.'
            };
        }

        if (status === 503) {
            return {
                success: false,
                status,
                errorCode: data.error || 'SERVICE_UNAVAILABLE',
                message: data.message || 'Odds data service is temporarily unavailable. Please try again later.'
            };
        }

        return {
            success: false,
            status,
            errorCode: data.error || 'SERVER_ERROR',
            message: data.message || 'Server error. Please try again later.'
        };
    }

    return {
        success: false,
        status: null,
        errorCode: 'NETWORK_ERROR',
        message: 'Unable to connect to server. Please check your internet connection.'
    };
};

const rawOddsService = {
    getRawOdds: async (sport, market) => {
        try {
            const response = await axios.get(`${API_URL}${BASE_PATH}`, {
                params: { sport, market },
                headers: getAuthHeaders()
            });

            const result = response.data;

            if (!result.success) {
                return {
                    success: false,
                    message: result.message || 'Failed to fetch odds data'
                };
            }

            return {
                success: true,
                data: result.data
            };
        } catch (error) {
            return handleApiError(error);
        }
    }
};

export default rawOddsService;
